import Controller from '@ember/controller';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type FlashMessagesService from 'garaje/services/flash-messages';
import type ReactRendererService from 'garaje/services/react-renderer';
import type StateService from 'garaje/services/state';
import type { Root } from 'react-dom/client';

export default class VisitorsDevicesPrintersOverviewController extends Controller {
  @service declare abilities: AbilitiesService;
  @service declare flashMessages: FlashMessagesService;
  @service declare router: RouterService;
  @service declare reactRenderer: ReactRendererService;
  @service declare state: StateService;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    const { PrinterOverviewView } = await import('reactRichComponents/visitors/devices/printers/PrinterOverviewView');
    if (this.isDestroying || this.isDestroyed) return;

    this.root = await this.reactRenderer.render(PrinterOverviewView, 'react__printer-overview-view', {
      companyId: this.state.currentCompany.id,
      locationId: this.state.currentLocation.id,
    });
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
